import React from "react";

// components
import TypeTable from "../misc/TypeTable";
import OpportunityTable from "../misc/OpportunityTable";
import CreateOpportunity from "../misc/CreateOportunity";
import SimpleTab from "../../../component/ui/tabs/SimpleTab";
import CreateOppotunityType from "../misc/CreateOppotunityType";

import Button from "../../../component/element/forms/Button";
import { FaPlus } from "react-icons/fa6";

const Opportunity = () => {
  const [focused, focusedSet] = React.useState<{
    id: string;
    name: string;
    button_name: string;
  }>({
    id: "opportunity",
    name: "Opportunity",
    button_name: "Create",
  });

  const [create, createSet] = React.useState<boolean>(false);
  const [type, typeSet] = React.useState<boolean>(false);

  return (
    <div>
      <div className="flex items-start justify-between">
        <div>
          <SimpleTab
            className="font-bold"
            items={[
              { id: "opportunity", name: "Opportunity", button_name: "Create" },
              { id: "type", name: "Type", button_name: "Create" },
            ]}
            onClick={(item) =>
              focusedSet(
                item as { id: string; name: string; button_name: string },
              )
            }
            focused={focused}
          />
        </div>
        <Button
          title={focused.button_name}
          children={<FaPlus className="mr-2" />}
          onClick={() => {
            if (focused.id === "opportunity") createSet(true);
            if (focused.id === "type") typeSet(true);
          }}
          className="px-4"
        />
      </div>

      <div className="mt-6">
        {focused.id === "opportunity" && <OpportunityTable />}
        {focused.id === "type" && <TypeTable />}
      </div>

      <CreateOpportunity show={create} onHandler={() => createSet(false)} />
      <CreateOppotunityType visible={type} onClose={() => typeSet(false)} />
    </div>
  );
};

export default Opportunity;
